// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__20r6q","OrderButton":"BuildControls_OrderButton__3vcRc","enable":"BuildControls_enable__3LLf2"};